import { firebaseDb as db } from '../firebase'

import { asyncRequest, asyncSuccess, asyncFail, cleanMessages } from '../actions'

// action types

// action creators
/**
 * Fetching all users is available only for superadmin
 * @param {String} userId
 */
export const fetchUsers = userId => {
  return dispatch => {
    dispatch(asyncRequest('fetchUsers'))

    const usersRef = db.collection('users')
    usersRef
      .get()
      .then(usersSnap => {
        const users = {}
        usersSnap.forEach(doc => {
          users[doc.id] = doc.data()
          users[doc.id].id = doc.id // TODO remove - already contains uid in data
        })
        dispatch(asyncSuccess('fetchUsers', { users }, null))
      })
      .catch(error => {
        console.log(error)
        dispatch(asyncFail('fetchUsers', error.code))
        dispatch(cleanMessages())
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/users.js